// src/viqai/api.js
// ─── Pont vers les helpers API déjà présents dans App.jsx ───────────────────
// App.jsx n'exporte rien (fichier unique de 47 000 lignes) et contient déjà
// `apiGet`, `apiPost`, `apiPatch`, `apiDelete`, `getAuthHeaders`, `API_URL` et
// `buildLeBonCoinUrl`. Les redéfinir ici créerait une seconde source de vérité
// pour l'authentification Firebase — exactement ce que la règle « réutiliser >
// réécrire » interdit.
//
// App.jsx appelle donc `initViqApi({...})` une seule fois au démarrage et ce
// module se contente de relayer.

let _api = null;

export function initViqApi(helpers) {
  _api = helpers;
}

function required() {
  if (!_api) throw new Error("initViqApi n'a pas été appelé : VIQ.AI n'a pas accès à l'API.");
  return _api;
}

export const apiGet = (path) => required().apiGet(path);
export const apiPost = (path, body) => required().apiPost(path, body);
export const apiPatch = (path, body) => required().apiPatch(path, body);
export const apiDelete = (path) => required().apiDelete(path);
export const buildLeBonCoinUrl = (criteria) => required().buildLeBonCoinUrl(criteria || {});
export const compressImageFile = (file) => required().compressImageFile(file);
export const apiUrl = () => required().API_URL;
// Le téléchargement de médias construit ses propres requêtes fetch (blob,
// en-têtes de disposition) : il lui faut le même jeton que les helpers JSON,
// pas une seconde implémentation de l'authentification Firebase.
export const getAuthHeaders = () => required().getAuthHeaders();

// ─── Flux SSE du tour de conversation ───────────────────────────────────────
// `fetch` plutôt qu'`EventSource` : il faut un POST avec des pièces jointes et
// l'en-tête d'authentification Firebase, qu'EventSource ne sait pas porter.
export async function streamMessage(body, onEvent, signal) {
  const { API_URL, getAuthHeaders } = required();
  const res = await fetch(`${API_URL}/api/viqai/message?stream=1`, {
    method: "POST",
    headers: await getAuthHeaders(),
    body: JSON.stringify(body),
    signal,
  });
  if (!res.ok || !res.body) {
    let detail = null;
    try { detail = await res.json(); } catch (e) {}
    const err = new Error(detail?.error || `Erreur ${res.status}`);
    err.code = detail?.code || null;
    err.subscribeRequired = !!detail?.subscribe_required;
    err.trial = detail?.trial || null;
    err.status = res.status;
    if (detail?.code === "CREDIT_LIMIT_REACHED") {
      try { window.dispatchEvent(new CustomEvent("viq-credits-changed", { detail: detail?.credits || null })); } catch (_) {}
    }
    throw err;
  }

  const reader = res.body.getReader();
  const decoder = new TextDecoder();
  let buffer = "";
  while (true) {
    const { done, value } = await reader.read();
    if (done) break;
    buffer += decoder.decode(value, { stream: true });
    // Le protocole SSE sépare les évènements par une ligne vide. Un événement
    // coupé en deux paquets réseau reste dans le tampon jusqu'à être complet.
    const parts = buffer.split("\n\n");
    buffer = parts.pop() || "";
    for (const part of parts) {
      const line = part.split("\n").find(l => l.startsWith("data:"));
      if (!line) continue;
      try {
        const event = JSON.parse(line.slice(5).trim());
        onEvent(event);
        if (event?.type === "final") {
          try { window.dispatchEvent(new CustomEvent("viq-credits-changed", { detail: event?.credits || null })); } catch (_) {}
        }
      }
      catch (e) { /* fragment illisible : on l'ignore plutôt que de couper le flux */ }
    }
  }
}
